import React from 'react'
import { Route } from 'react-router'

import { logRouting } from '../helpers/logger'

interface IProps {}

export const LogRoute: React.SFC<IProps> = props => (
  <Route>
    {({ location }) => {
      logRouting('at %s', location.pathname)
      return null
    }}
  </Route>
)
